
import { Component, Vue } from 'nuxt-property-decorator'

@Component({ name: 'XmarkLight' })
export default class XmarkLight extends Vue {}
